import { render, staticRenderFns } from "./ExpanderText.vue?vue&type=template&id=09463790&scoped=true&"
import script from "./ExpanderText.vue?vue&type=script&lang=js&"
export * from "./ExpanderText.vue?vue&type=script&lang=js&"
import style0 from "./ExpanderText.vue?vue&type=style&index=0&id=09463790&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09463790",
  null
  
)

export default component.exports